import { Controller, useFormContext } from 'react-hook-form';

import { FormHelperText } from '@mui/material';
import UploadBox from '../upload/upload-box';
import { UploadProps } from '../upload/types';

interface Props extends Omit<UploadProps, 'file'> {
  name: string;
  multiple?: boolean;
}

export default function RHFUploadBox({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <UploadBox file={field.value} error={!!error} {...other} />
          {!!error && (
            <FormHelperText error sx={{ px: 1.5 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
